function generateRows(count) {
  const names = [
    "Lucas Bennett",
    "Olivia Hayes",
    "Liam Johnson",
    "Emma Wilson",
    "Noah Brown",
    "Ava Davis",
  ];
  const rows = [];
  const startDate = new Date("2024-04-14");
  const endDate = new Date("2025-04-14");

  for (let i = 1; i <= count; i++) {
    const name = names[i % names.length];
    const imei = `35${Math.floor(
      100000000000000 + Math.random() * 900000000000000
    )}`;
    // Spread dates across 1 year
    const randomDate = new Date(
      startDate.getTime() +
        Math.random() * (endDate.getTime() - startDate.getTime())
    );
    const pickupStarted = randomDate.toLocaleString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
    const totalOrders = Math.floor(Math.random() * 50) + 20;
    const orderLines = Math.floor(Math.random() * 40) + 30;
    const totalItems = totalOrders + orderLines;

    rows.push({
      id: i,
      employeeName: name,
      deviceImei: imei,
      pickupStarted,
      totalOrders,
      orderLines,
      totalItems,
      handleRowClick: (params) => {
        const setSelectedJob = params.api.getRowParams(params.id).api
          .setSelectedJob;
        setSelectedJob(params.row);
        params.api.getRowParams(params.id).api.setOpen(true);
      },
    });
  }

  return rows;
}

export const rows = generateRows(40);
